import React from 'react';
import { useStaticQuery } from 'gatsby';
import LeafletMap from './LeafletMap/LeafletMap';
import { jsx as ___EmotionJSX } from "@emotion/react";
const ContactMap = () => {
  const data = useStaticQuery(query);
  const address = data.directusCompany.addresses[0];
  const addrStruc = {
    street: `${address.street} ${address.number.split('-')[0]}`,
    city: address.city,
    zip_code: address.zip_code,
    country: address.country
  };
  return ___EmotionJSX(LeafletMap, {
    address: addrStruc,
    name: data.directusCompany.display_name,
    showRoute: true
  });
};
const query = "1122272499";
export default ContactMap;